import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import { useImpersonation } from "../contexts/ImpersonationContext";

// One banner that handles both impersonation states.
// Phase 2 (acting as another user) takes precedence over Phase 1
// (read-only view-as) — they shouldn't co-occur in practice.
const ImpersonationBanner = () => {
    const { viewingHouse, stop, actingAs, me, stopLoginAs } = useImpersonation();
    const navigate = useNavigate();
    const [submitting, setSubmitting] = useState(false);

    if (actingAs) {
        const handleStop = async () => {
            setSubmitting(true);
            try {
                await stopLoginAs();
                navigate("/");
            } catch (e) {
                alert(e.message);
            } finally {
                setSubmitting(false);
            }
        };
        return (
            <div
                style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1040,
                    background: "#dc3545",
                    color: "#fff",
                    padding: "0.5rem 1rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #a71d2a",
                }}
            >
                <span>
                    <strong>Acting as</strong>{" "}
                    {me?.user?.email || me?.user?.id}
                    {" — "}every action attributes to this user; admin <code>{actingAs.email}</code> is recorded in the audit log
                </span>
                <Button size="sm" variant="light" onClick={handleStop} disabled={submitting}>
                    {submitting ? "Stopping..." : "Stop impersonating"}
                </Button>
            </div>
        );
    }

    if (viewingHouse) {
        return (
            <div
                style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1040,
                    background: "#ffc107",
                    color: "#000",
                    padding: "0.5rem 1rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #b78700",
                }}
            >
                <span>
                    <strong>Viewing as</strong>{" "}
                    {viewingHouse.ownerEmail || viewingHouse.houseDescription || viewingHouse.houseId}
                    {" — "}read-only mode (mutations will be rejected)
                </span>
                <Button size="sm" variant="dark" onClick={stop}>
                    Stop viewing
                </Button>
            </div>
        );
    }

    return null;
};

export default ImpersonationBanner;
